import { Link } from "@material-ui/core";
import { useSelector } from "react-redux";
import { InformationRequestAction } from "../../../domain/InformationRequestAction";
import { authSelector } from "../../../redux/selectors";
import { informationRequestService } from "../../../services";
import { DownloadLink } from "@ofqual/portal-components/components/DownloadLink";

export const DownloadAllLink: React.FC<{
  className: string;
  action: InformationRequestAction;
  organisationRecipientId: string;
}> = ({ className, action, organisationRecipientId }) => {
  const { token } = useSelector(authSelector);

  const getAllDocuments = async () => {
    const blob = await informationRequestService.downloadAllDocuments(
      action.informationRequestId,
      organisationRecipientId,
      action.id,
      {
        token,
      }
    );
    return blob;
  };
  return (
    <DownloadLink
      fileName={`ofqual-documents-${action.id}.zip`}
      getBlob={getAllDocuments}
    >
      {({ handleClick }) => (
        <Link component="button" className={className} onClick={handleClick}>
          Download All
        </Link>
      )}
    </DownloadLink>
  );
};
